import { Text } from "@foris/avocado-suite";
import { useTranslation } from "react-i18next";
import ItemInfoRow from "@modules/sections/GridSections/item-info-row";
import LinkRouter from "@common/components/link-router";
import type { AnnualOccurrence } from "../../adapters";
import type { AnnualScheduleContext } from "../../types";
import styles from "./sessionOccurrenceDetails.module.scss";

export default function SessionOccurrenceDetails({
  occurrence,
  context,
}: {
  occurrence: AnnualOccurrence;
  context: AnnualScheduleContext;
}) {
  const { t } = useTranslation();
  const contextUrl = `${context.workspaceId}/${context.scenarioId}/${context.originId}`;
  const instructors = occurrence.instructors?.filter(Boolean) ?? [];
  const classrooms = occurrence.classrooms?.filter(Boolean) ?? [];
  return (
    <div className={styles.sessionOccurrenceDetails}>
      <ItemInfoRow
        columns={[
          {
            icon: "calendar",
            title: `${t("calendar-view.event-modal.columns.schedule")}:`,
            text: `${occurrence.startingTime.slice(0, 5) || "-"} - ${occurrence.endingTime.slice(0, 5) || "-"}`,
          },
        ]}
      />
      <ItemInfoRow
        columns={[
          {
            icon: "user",
            title: `${t("calendar-view.event-modal.columns.instructor")}:`,
            customContent: (
              <div className={styles.sessionOccurrenceDetails_resources}>
                {instructors.length ? (
                  instructors.map(instructor => {
                    const label = [instructor.code, instructor.name].filter(Boolean).join(" - ");
                    return instructor.hasAccess ? (
                      <LinkRouter
                        key={instructor.id}
                        to={`/scheduler/editor/instructor/${contextUrl}/${instructor.id}`}
                      >
                        {label}
                      </LinkRouter>
                    ) : (
                      <Text key={instructor.id}>{label}</Text>
                    );
                  })
                ) : (
                  <Text>-</Text>
                )}
              </div>
            ),
          },
        ]}
      />
      {classrooms.length ? (
        classrooms.map(classroom => (
          <ItemInfoRow
            key={classroom.id}
            columns={[
              {
                icon: "building",
                title: `${t("calendar-view.event-modal.columns.classroom")}:`,
                text: classroom.code || classroom.name || "-",
                link: `/scheduler/editor/classroom/${contextUrl}/${classroom.id}`,
              },
              {
                title: `${t("calendar-view.event-modal.columns.building")}:`,
                text: classroom.building?.code || classroom.building?.name || "-",
              },
            ]}
          />
        ))
      ) : (
        <ItemInfoRow
          columns={[
            {
              icon: "building",
              title: `${t("calendar-view.event-modal.columns.classroom")}:`,
              text: "-",
            },
            { title: `${t("calendar-view.event-modal.columns.building")}:`, text: "-" },
          ]}
        />
      )}
    </div>
  );
}
